import { TreeListCellProps } from '@progress/kendo-react-treelist';
import { MouseEvent, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'src/components/design-system/Button';
import useViewProfileModal from 'src/sections/work_area/ViewProfileModal';
import { stopPropagation } from 'src/utils';

const ProfileCell = (props: TreeListCellProps) => {
  const { t } = useTranslation();
  const handleViewProfile = useViewProfileModal(props.dataItem);

  const handleDetailsClick = useCallback(
    (e: MouseEvent) => {
      stopPropagation(e);
      handleViewProfile();
    },
    [handleViewProfile]
  );

  return (
    <td className={props.className} style={props.style}>
      <div className="flex items-stretch w-full h-full justify-center">
        <Button color="info" onClick={handleDetailsClick} size="sm" className="w-fit text-[12px]">
          {t('details')}
        </Button>
      </div>
    </td>
  );
};

export default ProfileCell;
